<script>
    export default {
        name: "AppSchema",
        props: {
            name: String,
            description: String,
            alternateName: String,
            phone: String,
            email: String,
            url: String,
            legalName: {
                type: String,
                default: "ООО 'Проект Ы'",
            },
            postalCode: {
                type: String,
                default: "129226",
            },
            addressLocality: {
                type: String,
                default: "Москва, Россия",
            },
            streetAddress: {
                type: String,
                default: "ул. Сельскохозяйственная, дом 11",
            },
        },
    };
</script>

<template>
    <div itemscope itemtype="https://schema.org/Organization" style="display: none">
        <meta itemprop="name" :content="name" />
        <meta itemprop="alternateName" :content="alternateName" />
        <meta itemprop="legalName" :content="legalName" />
        <meta itemprop="description" :content="description" />
        <link itemprop="url" :href="url" />

        <meta itemprop="email" :content="email" />
        <div itemprop="address" itemscope itemtype="https://schema.org/PostalAddress">
            <meta itemprop="addressLocality" :content="addressLocality" />
            <meta itemprop="postalCode" :content="postalCode" />
            <meta itemprop="streetAddress" :content="streetAddress" />
        </div>
        <meta v-if="phone" itemprop="telephone" :content="phone" />
    </div>
</template>

<style lang="scss"></style>
